import { render, staticRenderFns } from "./ErrorModal.vue?vue&type=template&id=282eb8a6&scoped=true"
import script from "./ErrorModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./ErrorModal.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ErrorModal.vue?vue&type=style&index=0&id=282eb8a6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "282eb8a6",
  null
  
)

export default component.exports